import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Target } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const options = ['Product detail', 'Listening', 'Asking questions', 'Clinical proof'];
export const Screen3Ranking = ({
  onNext
}: Props) => {
  const [selected, setSelected] = useState<number | null>(null);
  const [revealed, setRevealed] = useState(false);
  const handleSelect = (index: number) => {
    if (revealed) return;
    setSelected(index);
    setTimeout(() => {
      setRevealed(true);
    }, 600);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-548">
      {/* Background Video */}
      <div className="absolute inset-0" data-id="element-549">
        <video src="https://cdn.magicpatterns.com/uploads/mNUFnTYqaYhezKUw6apcfK/Cinematic shots when Bored at the Airport_.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover opacity-90" data-id="element-550" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-red-950/20 via-slate-950/30 to-slate-950/80" data-id="element-551" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-552">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-4" data-id="element-553">
          03 — Field Challenge
        </motion.span>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="w-12 h-12 bg-red-500/20 rounded-2xl flex items-center justify-center mb-6 border border-red-500/30" data-id="element-554">
          <Target className="w-6 h-6 text-red-500" data-id="element-555" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl font-bold text-white leading-tight mb-8" data-id="element-556">
          What's the most important first 30 seconds in a congress conversation?
        </motion.h2>

        <div className="space-y-3 flex-1" data-id="element-557">
          {options.map((opt, i) => {
          const isSelected = selected === i;
          const isCorrect = i === 1 || i === 2; // Both listening and asking are good
          let buttonClass = 'w-full text-left p-4 rounded-2xl border transition-all duration-300 ';
          if (!revealed) {
            buttonClass += isSelected ? 'bg-red-600/20 border-red-500 text-white' : 'bg-slate-900/80 border-slate-800 text-slate-300 hover:border-slate-600';
          } else {
            if (isCorrect) {
              buttonClass += 'bg-green-500/20 border-green-500 text-white';
            } else if (isSelected) {
              buttonClass += 'bg-slate-800/50 border-slate-700 text-slate-500 opacity-50';
            } else {
              buttonClass += 'bg-slate-900/30 border-slate-800 text-slate-600 opacity-50';
            }
          }
          return <motion.button key={opt} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} onClick={() => handleSelect(i)} disabled={revealed} className={buttonClass} data-id="element-558">
                <span className="text-sm font-medium" data-id="element-559">{opt}</span>
              </motion.button>;
        })}
        </div>

        <AnimatePresence data-id="element-560">
          {revealed && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6" data-id="element-561">
              <p className="text-sm text-slate-400 italic text-center mb-4" data-id="element-562">
                Let's hear their perspective...
              </p>
              <button onClick={onNext} className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-563">
                <span data-id="element-564">Resume Video</span>
                <ArrowRight className="w-5 h-5" data-id="element-565" />
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
};